import builder from '../builder';
import AlarmBell from '../../streamline-icons/light/alarm-bell.svg';

export default builder('IconAlarmBellLight', AlarmBell);
